import React from 'react'
import { Controller } from 'front-end-core/core/Router'
import { defaultSort } from 'constants/caSortOptions'
import Left from 'pages/search/Left'
import NotFound from 'components/NotFound'
import getUrl from 'front-end-core/core/url'
import { SEARCH } from 'constants/controllers'
import { QAHeader } from './Header'
import PagedContainer from 'redux/containers/pages/search/PagedContainer'
import InfiniteContainer from 'redux/containers/pages/search/InfiniteContainer'

export default new Controller({
  name: SEARCH,
  route: ':aol/(:flavour/)search/:searchType',
  controller (Router, { scrollMain, query, pageView, params: { aol, flavour, searchType } }, render) {
    const { q: searchPhrase, p: pageNumber = '1' } = query
    const pageLimit = 10
    const pageId = getUrl(SEARCH, { aol, flavour: searchType === 'qa' && flavour, searchPhrase, searchType, pageNumber: pageNumber === 'all' && 'all' })
    const bottleLink = flavour => getUrl(SEARCH, { aol, flavour, searchPhrase, searchType })
    const Header = searchType === 'qa' ? () => <QAHeader {...{ aol, flavour, searchType, searchPhrase }} /> : null

    if (searchType === 'ca' && !query.sort) {
      query.sort = defaultSort
    }

    const layoutData = {
      bottleLink,
      className: searchType,
      aol,
      flavour,
      pageId,
      pageView,
      query,
      searchPhrase,
      searchType
    }

    if (pageNumber === 'all') {
      render(
        {
          Main: InfiniteContainer,
          Header,
          Left
        },
        {
          aol,
          flavour,
          pageLimit,
          pageNumber: false,
          searchPhrase,
          searchType,
          query
        },
        layoutData
      )
    } else if (+pageNumber > 0) {
      render(
        {
          Main: PagedContainer,
          Header,
          Left
        },
        {
          flavour,
          aol,
          pageLimit,
          pageNumber: +pageNumber || 1,
          query,
          searchPhrase,
          searchType
        },
        layoutData
      )
    } else {
      render(
        { Main: NotFound },
        {},
        { pageId }
      )
    }

    return pageId
  }
})
